export default __webpack_public_path__ + "static/media/au.85ccb166.svg";